export default {
  getCities: (state) => state.cities,
  getCitiesByStateID: (state) => state.cities_by_state_id,
};
